import React, { ReactNode } from "react"
import { FeatureFlagsProvider } from "../context/FeatureFlagsContext/FeatureFlagsContext"

export default ({ element }: {element: ReactNode}) => {
  return <FeatureFlagsProvider>{element}</FeatureFlagsProvider>
}
